import React from "react";
import { TooltipComp } from "../../components";
import ClipLoaderComponent from "../loader/ClipLoaderComponent";
import { dollarFieldsMapper, toolTipMapper } from "../../utils/constants";
import { formatNumber } from "../../utils/helper";
import { useLocation } from "react-router-dom";

export default function OverviewCard({
  title,
  value,
  remainTime,
  isFetching,
  info,
  percentage,
  healthStatus,
  overviewTooltipDetail,
  validatorStake
}) {
  const { pathname } = useLocation();

  const handleValue = (title, value) => {
    if (title?.includes("cap") || title?.includes("stake") || title?.includes("rewards")) {
      if(title === "validator_stake"){
        return formatNumber(validatorStake);
      }
      return formatNumber(value);
    } else if (title === "price") {
      return Number(value)?.toFixed(4);
    } else {
      return value?.toLocaleString("en-US");
    }
  };

  return (
    <div className="h-full min-h-[120px] lg:min-h-[139px] rounded-[18px] border-[#FDFDFD1A] p-[14px] md:p-5 flex gap-0 flex-col justify-between bg-white/[0.08] xl:backdrop-blur-[10px]">
      <div className="flex items-center gap-2 text-dim/50 md:-mb-1 mb-0 pb-2">
        <h4 className="text-xs lg:text-sm leading-4 font-medium -tracking-04 capitalize mb-0">
          {title === "price"
            ? "$VANRY Token Price"
            : title?.split("_").join(" ")}
        </h4>
        {info && toolTipMapper[title] && (
          <TooltipComp
            tooltipId={title}
            tooltipTitle={title?.split("_").join(" ")}
            tooltipDetail={
              overviewTooltipDetail
                ? overviewTooltipDetail[title]
                : ""
            }
          />
        )}
      </div>
      {isFetching && <ClipLoaderComponent className="loader_cards" size={35} />}

      {!isFetching && (
        <div className="flex items-end gap-1 md:gap-[10px]">
          {title === "health_status" && (
            <div className="p-[10px] rounded-xl text-green bg-green/[.06] flex items-center justify-center text-sm lg:text-[22px] laptop:text-[26px] leading-none font-semibold -tracking-12 gap-[6px] lg:gap-[10px]">
              <span className="w-2 h-2 laptop:w-3 laptop:h-3 bg-green rounded-full"></span>
              Healthy
            </div>
          )}

          {title !== "health_status" && (
            <h3 className="text-[22px] lg:text-[38px] leading-[42px] lg:leading-[34px] -tracking-[2.04px] font-semibold text-[#50FDDB]">
              {dollarFieldsMapper[title] && pathname === "/calculator" && "$"}
              {handleValue(title, value)}
            </h3>
          )}

          {remainTime && (
            <div className="bg-tagcolor/[.08] py-1 px-[6px] lg:py-2 lg:px-[10px] rounded-full text-[10px] lg:text-[14px] font-medium capitalize text-tagcolor">
              18 Minutes ago
            </div>
          )}

          {percentage && (
            <div className="text-[10px] lg:text-sm font-normal uppercase text-[#FF3B3B]">
              {percentage}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
